/* =============================================================================
 WIPER EXPRESS, COMPANY PAGES INTERACTIONS
 File: assets/wx-company.js
 Purpose: scroll-triggered reveal animations for .wx-reveal elements.
 Shared across all wx-company.css-using sections. Safe to include
 multiple times (idempotent) since it scopes itself per .wx-co root.
 ============================================================================= */
(function () {
 'use strict';

 var prefersReduced =
 window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

 function reveal(root) {
 if (!root || root.dataset.wxCoReveal === 'bound') return;
 root.dataset.wxCoReveal = 'bound';

 var targets = root.querySelectorAll('.wx-reveal');
 if (!targets.length) return;

 if (prefersReduced || !('IntersectionObserver' in window)) {
 targets.forEach(function (el) { el.classList.add('is-visible'); });
 return;
 }

 var io = new IntersectionObserver(function (entries) {
 entries.forEach(function (entry) {
 if (entry.isIntersecting) {
 entry.target.classList.add('is-visible');
 io.unobserve(entry.target);
 }
 });
 }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

 targets.forEach(function (el) { io.observe(el); });
 }

 function boot() {
 document.querySelectorAll('.wx-co').forEach(reveal);
 }

 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', boot);
 } else {
 boot();
 }

 // Shopify Section Rendering API, re-bind on section reload in Theme Editor
 document.addEventListener('shopify:section:load', boot);
})();